import type { SettingsState } from './SettingsState';

/** Mirrors the Android and iOS settings screens, which likewise take the address and hold nothing. */
export function useSettings(email: string): { state: SettingsState } {
  return { state: { email } };
}
